<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>门店提现审批</el-breadcrumb-item>
    </el-breadcrumb>

    <el-tabs v-model="activeName" type="border-card" v-loading.fullscreen.lock="fullscreenloading">
      <!-- 续费订单 strat -->
      <el-tab-pane label="订单列表" name="first">
        <!-- 续费订单 start -->
        <el-form :inline="true" :model="keywords">
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入提现单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择提现状态" class="select">
              <el-option label="提现状态:请选择" value="0"></el-option>
              <el-option label="审核中" value="1"></el-option>
              <el-option label="审核失败" value="2"></el-option>
              <el-option label="审核成功,待转账" value="3"></el-option>
              <el-option label="转账成功" value="4"></el-option>
              <el-option label="转账失败" value="5"></el-option>
              <el-option label="支付平台繁忙,稍后重试" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            门店已提现总金额:{{Sumjine}}
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="提现单号" min-width="20%"></el-table-column>
          <el-table-column prop="Jigouname" label="门店名" min-width="10%"></el-table-column>
          <el-table-column prop="Dailishangname" label="门店所有人姓名" min-width="10%"></el-table-column>
          <el-table-column prop="Dailishangphone" label="门店所有人手机" min-width="10%"></el-table-column>
          <el-table-column prop="Tixiantype" label="提现类型" min-width="6%"></el-table-column>
          <el-table-column prop="Nickname" label="提现账号" min-width="12%">
            <template slot-scope="scope">
              <img :src="scope.row.Headimgurl" min-width="24" height="24" />
              昵称:{{scope.row.Nickname}}
            </template>
          </el-table-column>
          <el-table-column prop="Jine" label="提现金额" min-width="5%"></el-table-column>
          <el-table-column prop="Statuss" label="提现状态" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="申请时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="12%">
            <template v-slot="scope">
              <el-button v-if="scope.row.Status == 1 && SubRule_WithdrawalApproval_ShenPi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="applyOk(scope.row)">同意提现</el-button>
              <el-button v-if="scope.row.Status == 1 && SubRule_WithdrawalApproval_ShenPi" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="applyFail(scope.row)">拒绝提现</el-button>
              <el-button v-if="scope.row.Status == 3 && SubRule_WithdrawalApproval_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="fangkuan(scope.row)">同意转账</el-button>
              <el-button v-if="scope.row.Status == 6 && SubRule_WithdrawalApproval_CaiWu" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="fangkuan(scope.row)">重新尝试转账</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 续费订单 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 管理员 end -->

      <!-- 转账 start -->
      <el-tab-pane label="转账" v-if="displayTransfer" name="second">
        <el-form :model="transferForm" ref="transferFormRef" label-width="154px">
          <el-form-item label="提现类型：">
              {{transferForm.tixiantype}}
          </el-form-item>
          <el-form-item label="提现账号：">
              <img class="headImg" :src="transferForm.headimgurl"> 昵称:{{transferForm.nickname}}
          </el-form-item>
          <el-form-item label="提现状态：">
              {{transferForm.statuss}}
          </el-form-item>
          <el-form-item label="累计已获得分润金额：" class="red">
              {{transferForm.sumbonus}}
          </el-form-item>
          <el-form-item label="累计已成功提现金额：" class="red">
              {{transferForm.sumjine}}
          </el-form-item>
          <el-form-item label="当前剩余未提现金额：" class="red">
              {{transferForm.mendianbonus}}
          </el-form-item>
          <el-form-item label="本次申请的提现金额：">
              {{transferForm.jine}}
          </el-form-item>

          <el-form-item>
            <el-button v-if="transferForm.pstatus == 0" type="primary" @click="t1">第一步：江苏睿世力转账给山西睿世力</el-button>
            <el-button v-if="transferForm.pstatus == 1" type="primary" @click="t2">第二步：山西睿世力转账给运营商</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 转账 end -->

      <!-- 年度汇总 start -->
      <el-tab-pane label="年度汇总">
        <el-form :inline="true" :model="keywordsYear">
          <el-form-item label="">
            <el-select v-model="keywordsYear.year" placeholder="请选择年份" class="select">
              <el-option label="2020年" value="2020"></el-option>
              <el-option label="2021年" value="2021"></el-option>
              <el-option label="2022年" value="2022"></el-option>
              <el-option label="2023年" value="2023"></el-option>
              <el-option label="2024年" value="2024"></el-option>
              <el-option label="2025年" value="2025"></el-option>
              <el-option label="2026年" value="2026"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearchYear">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="YearList" border stripe class="mt15">
          <el-table-column prop="Name" label="月份"></el-table-column>
          <el-table-column prop="MoneyApply" label="该月总申请金额"></el-table-column>
          <el-table-column prop="MoneyOk" label="该月总申请金额中已转账金额"></el-table-column>
          <el-table-column prop="MoneyLeft" label="该月总申请金额中未转账金额"></el-table-column>
        </el-table>
      </el-tab-pane>
      <!-- 年度汇总 end -->

    </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyWithdrawalApproval',
  data () {
    return {
      loading: false,
      activeName: 'first',
      keywords: {
        jigouid: '-1',
        jigouname: '',
        orderid: '',
        status: '0',
        begintime: '',
        endtime: ''
      },
      keywordsYear: {
        year: '2026'
      },
      transferForm: {
        id: '',
        tixiantype: '',
        headimgurl: '',
        nickname: '',
        statuss: '',
        sumbonus: '',
        sumjine: '',
        mendianbonus: '',
        jine: '',
        pstatus: 0
      },
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      Sumjine: 0,
      displayTransfer: false,
      SubRule_WithdrawalApproval_ShenPi: false,
      SubRule_WithdrawalApproval_CaiWu: false,
      YearList: [],
      fullscreenloading: false
    }
  },
  mounted () {
    this.apiWithdrawalApprovalnum()
    this.apiWithdrawalApprovallist()
    this.WithdrawalMonthlyStatistics()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_WithdrawalApproval_ShenPi', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_WithdrawalApproval_ShenPi = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_WithdrawalApproval_CaiWu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_WithdrawalApproval_CaiWu = true
      }
    })
  },
  methods: {
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiWithdrawalApprovalnum()
      this.apiWithdrawalApprovallist()
    },
    clickSearchYear(){
      this.WithdrawalMonthlyStatistics()
    },
    applyOk (row) {
      this.$confirm('是否同意提现?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiWithdrawalApprovalApplyOk(row.Id)
      })
    },
    applyFail (row) {
      this.$confirm('是否拒绝提现?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiWithdrawalApprovalApplyFail(row.Id)
      })
    },
    fangkuan (row) {
      this.displayTransfer = true
      this.activeName = 'second'

      this.transferForm.id = row.Id
      this.transferForm.tixiantype = row.Tixiantype
      this.transferForm.headimgurl = row.Headimgurl
      this.transferForm.nickname = row.Nickname
      this.transferForm.statuss = row.Statuss
      this.transferForm.sumbonus = row.Sumbonus
      this.transferForm.sumjine = row.Sumjine
      this.transferForm.mendianbonus = row.Mendianbonus
      this.transferForm.jine = row.Jine
      this.transferForm.pstatus = row.Pstatus
    },
    clickreturn () {
      this.displayTransfer = false
      this.activeName = 'first'
    },
    handleCurrentPageChange (selectedPageNo) {
      this.selectedPageNo = selectedPageNo
      this.apiWithdrawalApprovallist()
    },
    t1 () {
      this.$confirm('是否同意江苏睿世力转账给山西睿世力?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiWithdrawalApprovalTransfer1()
      })
    },
    t2 () {
      this.$confirm('是否同意山西睿世力转账给运营商?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiWithdrawalApprovalTransfer2()
      })
    },
    apiWithdrawalApprovallist: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        status: that.keywords.status,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovallist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.Sumjine = response.data.Sumjine
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiWithdrawalApprovalnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        status: that.keywords.status,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovalnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiWithdrawalApprovalApplyOk: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovalApplyOk, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiWithdrawalApprovalnum()
            that.apiWithdrawalApprovallist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiWithdrawalApprovalApplyFail: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovalApplyFail, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiWithdrawalApprovalnum()
            that.apiWithdrawalApprovallist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiWithdrawalApprovalTransfer1: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.transferForm.id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovalTransfer1, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.transferForm.pstatus = 1
            that.apiWithdrawalApprovalnum()
            that.apiWithdrawalApprovallist()
          }
          Vue.prototype.FunCheckApiCode(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiWithdrawalApprovalTransfer2: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.transferForm.id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalApprovalTransfer2, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.transferForm.pstatus = 2
            that.apiWithdrawalApprovalnum()
            that.apiWithdrawalApprovallist()
          }
          Vue.prototype.FunCheckApiCode(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    WithdrawalMonthlyStatistics: function (year) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        year: that.keywordsYear.year
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_WithdrawalMonthlyStatistics, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.YearList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box{
    display: flex;
}
.profit{
    display: flex;
    align-items: center;
    padding-bottom: 5px;
    margin-right: 100px;

    & li:first-child{
        width: 168px;

        & em{
            font-style: normal;
            color: #999;
            font-size: 12px;
        }
    }
    & li:last-child{
        flex: 1;

        & span{
            display: inline-block;
            padding-right: 5px;
            color: #f56c6c;
            font-size: 16px;
        }
    }
    & li.firstLi{
        width: 128px;
    }
}
.red{
    color: #F56C6C
}
.el-form-item {
    margin-bottom: 0px;
}
.headImg{
    width: 16px;
    height: 16px;
    vertical-align: -3px;
}
</style>
